import baseUrl from "../lightingApiHost";
import { callApiWithRetry } from "./retry";

const getStore = storeId => {
  const url = `${baseUrl}stores/${storeId}`;
  return callApiWithRetry(url);
};

const getStores = () => {
  return callApiWithRetry(`${baseUrl}stores`);
};

const getLatestStoreZones = () => {
  return callApiWithRetry(`${baseUrl}stores/zones`);
};

const getZoneSceneLevels = (storeId, zoneId) => {
  const url = `${baseUrl}stores/${storeId}/zones/${zoneId}/scenes-configuration`;
  return callApiWithRetry(url);
};

const upsertZoneSceneLevels = (
  storeId,
  zoneId,
  zoneSceneLevels,
  storeConfigurationVersion,
  storeZoneScenesConfigurationVersion
) => {
  const url = `${baseUrl}stores/${storeId}/zones/${zoneId}/scenes-configuration`;

  const headers = {
    "Content-Type": "application/json"
  };
  const data = {
    ...zoneSceneLevels,
    version: storeZoneScenesConfigurationVersion
  };
  data.storeConfigurationVersion = storeConfigurationVersion;
  const config = {
    headers,
    method: "PUT",
    body: JSON.stringify(data)
  };

  return callApiWithRetry(url, config);
};

const getStoreWithConfiguration = storeId => {
  const url = `${baseUrl}stores/${storeId}`;
  return callApiWithRetry(url);
};

const getStoreZoneConfiguration = (storeId, zoneId) => {
  const url = `${baseUrl}stores/${storeId}/configuration/zones/${zoneId}/`;
  return callApiWithRetry(url);
};

const setStoreZoneConfiguration = (storeId, zoneId, data) => {
  const url = `${baseUrl}stores/${storeId}/configuration/zones/${zoneId}/`;

  const headers = {
    "Content-Type": "application/json"
  };

  const config = {
    headers,
    method: "PUT",
    body: JSON.stringify(data)
  };

  return callApiWithRetry(url, config);
};

const completeCommissioning = storeId => {
  const url = `${baseUrl}stores/${storeId}/commissioning-complete`;
  const config = {
    method: "POST"
  };
  return callApiWithRetry(url, config);
};

const deleteStoreZone = (storeId, zoneId) => {
  const headers = {
    "Content-Type": "application/json"
  };
  const url = `${baseUrl}stores/${storeId}/zones/${zoneId}`;
  const body = {
    storeId: storeId,
    zoneId: zoneId
  };
  const config = {
    headers,
    method: "delete",
    body: JSON.stringify(body)
  };
  return callApiWithRetry(url, config);
};

const getStoreStatus = storeId => {
  const url = `${baseUrl}stores/${storeId}/status`;
  return callApiWithRetry(url);
};

const sendSceneTest = (storeId, scene) => {
  const url = `${baseUrl}scene-tests`;

  const headers = {
    "Content-Type": "application/json"
  };

  const data = {
    storeId: storeId,
    scene: scene
  };

  const config = {
    headers,
    method: "POST",
    body: JSON.stringify(data)
  };

  return callApiWithRetry(url, config);
};

const disableManagersOverride = storeId => {
  const url = `${baseUrl}stores/${storeId}/disable-managers-override`;
  const config = {
    method: "POST"
  };
  return callApiWithRetry(url, config);
};

const getSchedule = scheduleId => {
  const url = `${baseUrl}schedules/${scheduleId}`;
  return callApiWithRetry(url);
};

const getOverride = overrideId => {
  const url = `${baseUrl}overrides/${overrideId}`;
  return callApiWithRetry(url);
};

const getCurrentOverridesForStore = storeId => {
  const url = `${baseUrl}overrides/${storeId}/current`;
  return callApiWithRetry(url);
};

const getOpeningHours = (storeId, date) => {
  const url = `${baseUrl}stores/${storeId}/opening-hours?date=${date}`;
  return callApiWithRetry(url);
};

const createOverride = (
  name,
  stores,
  zones,
  allZonesSelected,
  scene,
  start,
  end,
  daysOfWeek,
  isRecurring
) => {
  const url = `${baseUrl}overrides`;

  const headers = {
    "Content-Type": "application/json"
  };

  const data = {
    name: name,
    stores: stores,
    scene: scene,
    start: start,
    end: end,
    daysOfWeek: daysOfWeek,
    isRecurring: isRecurring
  };

  if (allZonesSelected) {
    data.allZonesSelected = allZonesSelected;
  } else {
    data.zones = zones;
  }

  const config = {
    headers,
    method: "POST",
    body: JSON.stringify(data)
  };

  return callApiWithRetry(url, config);
};

const updateOverride = (
  overrideId,
  name,
  stores,
  zones,
  allZonesSelected,
  scene,
  start,
  end,
  version,
  daysOfWeek,
  isRecurring
) => {
  const url = `${baseUrl}overrides/${overrideId}`;

  const headers = {
    "Content-Type": "application/json"
  };

  const data = {
    name: name,
    stores: stores,
    scene: scene,
    start: start,
    end: end,
    version: version,
    daysOfWeek: daysOfWeek,
    isRecurring: isRecurring
  };

  if (allZonesSelected) {
    data.allZonesSelected = allZonesSelected;
  } else {
    data.zones = zones;
  }

  const config = {
    headers,
    method: "PUT",
    body: JSON.stringify(data)
  };

  return callApiWithRetry(url, config);
};

const getCurrentOverrides = () => {
  const url = `${baseUrl}overrides/current`;
  return callApiWithRetry(url);
};

const getStatus = () => {
  const url = `${baseUrl}status`;
  return callApiWithRetry(url);
};

export default {
  getStore,
  getStores,
  getLatestStoreZones,
  getZoneSceneLevels,
  upsertZoneSceneLevels,
  getStoreWithConfiguration,
  getStoreZoneConfiguration,
  setStoreZoneConfiguration,
  completeCommissioning,
  deleteStoreZone,
  getStoreStatus,
  sendSceneTest,
  getSchedule,
  createOverride,
  getCurrentOverrides,
  getOverride,
  updateOverride,
  getStatus,
  getOpeningHours,
  getCurrentOverridesForStore,
  disableManagersOverride
};
